import { useEffect } from 'react';

const ORIGIN = 'https://www.iidakenchikuiruma.com';
const SITE_NAME = '飯田建築有限会社';
const DEFAULT_IMAGE = `${ORIGIN}/images/background_light.jpg`;

/** name 属性 / property 属性の meta を用意（無ければ作る）して中身を差し替える */
function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * ページ別の title / description / OGP / canonical を設定する。
 *
 * react-snap がプリレンダリング時に DOM をそのまま HTML 化するため、
 * useEffect での書き換えでも静的HTMLに反映される（クローラも読める）。
 */
export default function PageMeta({ title, description, path, image }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME}｜埼玉県入間市の工務店`;
  const url = `${ORIGIN}${path || '/'}`;
  const ogImage = image ? `${ORIGIN}${image}` : DEFAULT_IMAGE;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('name', 'description', description);
    setLink('canonical', url);

    setMeta('property', 'og:type', path === '/' ? 'website' : 'article');
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', ogImage);
    setMeta('property', 'og:locale', 'ja_JP');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);
  }, [fullTitle, description, url, ogImage, path]);

  return null;
}
